import { render, staticRenderFns } from "./ForcesSimulator.vue?vue&type=template&id=5f3ddd83&scoped=true&"
import script from "./ForcesSimulator.vue?vue&type=script&lang=js&"
export * from "./ForcesSimulator.vue?vue&type=script&lang=js&"
import style0 from "./ForcesSimulator.vue?vue&type=style&index=0&id=5f3ddd83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ddd83",
  null
  
)

export default component.exports